import { render } from "./donateinfo.vue?vue&type=template&id=312be997&scoped=true"
import script from "./donateinfo.vue?vue&type=script&lang=js"
export * from "./donateinfo.vue?vue&type=script&lang=js"

import "./donateinfo.vue?vue&type=style&index=0&id=312be997&lang=scss&scoped=true"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-312be997"]])

export default __exports__